module.exports = __webpack_public_path__ + "static/media/close-dark.f0f945f9.svg";